import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { CaptainCrudService } from 'src/app/shared/services/captain-crud.service';
import { Captain } from 'src/app/shared/interfaces/captain';


@Component({
  selector: 'app-captains',
  templateUrl: './captains.component.html',
  styleUrls: ['./captains.component.scss']
})
export class CaptainsComponent implements OnInit {

  captains: Captain[];
  captain: Captain;
  selectedCaptains: Captain[] = [];

  captainDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private captainService : CaptainCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Captains'}
    ];

    this.captains = [];
    this.captain = { } as Captain ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.captainService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.captains = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Captain = jsonItem as Captain;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.captains.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.captainService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.captains);
            doc.save('captains.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.captains);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "captains");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedCaptains);
      // console.log('SAVEC CSV LOCATIONS ', this.captains);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedCaptains, 'captains', exportCols);
   // this.exportService.exportToCsv(this.captains, 'captains', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.captain = {} as Captain;
    this.submitted = false;
    this.captainDialog = true;
  }

  deleteSelectedCaptains() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected captains?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.captains = this.captains.filter(val => !this.selectedCaptains.includes(val));
            
            this.selectedCaptains.forEach( captain => this.captainService.delete(captain.$key));
            this.selectedCaptains = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Captainss Deleted', life: 3000});
        }
    });
  }

  editCaptain(captain: Captain) {
    this.captain = {...captain};
    this.captainDialog = true;
  }

  deleteCaptain(captain: Captain) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + captain.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.captains = this.captains.filter(val => val.$key !== captain.$key);
            this.captain = {} as Captain;
            this.captainService.delete(captain.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Captain Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.captainDialog = false;
    this.submitted = false;
  }

  saveCaptain() {
    this.submitted = true;

    if ( this.captain.name.trim() ) {
      if (this.captain.$key) {
          this.captains[this.findIndexById(this.captain.$key)] = this.captain;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Captain Updated', life: 3000});
          this.captainService.update(this.captain);
        } else {
          this.captain.position = this.captains.length;
          this.captainService.add(this.captain);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Captain Created', life: 3000});
      this.captains = [...this.captains];
    }

    this.captainDialog = false;
    this.captain = { } as Captain;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.captains.length; i++) {
        if (this.captains[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeCaptain(captain : Captain) {
    this.captainService.update(captain);
  }

  completePosition(captain : Captain) {
    if ( this.newPosition > -1 ) {
        captain.position = this.newPosition;
        captain = this.checkPositionLimits(captain);
        this.reorderElements(captain);
        //this.updateDB(captain);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.captains);
    // const myClonedArray = [];
    // this.captains.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.captains.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.captains.length - 1 - event.dropIndex;
    const captainToMove = this.captains[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.captains[index] = this.captains[index+1];
        this.captains[index].position = index;
        this.captainService.update(this.captains[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.captains[index] = this.captains[index-1];
        this.captains[index].position = index;
        this.captainService.update(this.captains[index]);
      }
    } 
    this.captains[endIndex] = captainToMove;
    this.captains[endIndex].position = endIndex;
    this.captainService.update(this.captains[endIndex]);
  }

  // onFieldEdit(captain: Spray, fieldName: string): void {
  //   //console.log(this.captains);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + captain[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       captain.position = this.newPosition;
  //       captain = this.checkPositionLimits(captain);
  //       this.reorderElements(captain);
  //       //this.updateDB(captain);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(captain);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.captains.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, captain: Captain) {
    // console.log("event" +event);
    if (captain.position != null && captain.position > -1) {
      this.previousPosition = captain.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(captain: Captain) {
    console.log('check ',captain.position + ' ' + this.captains.length);
    if (!captain.position) {
     // console.log('check 1');
      return this.captain;
    }
    if (captain.position < 0) {
      captain.position = 0;
      // console.log('check 2');
      return captain;
    }
    if (captain.position > this.captains.length) {
      captain.position = this.captains.length - 1;
    //  console.log('check 3', captain.position);
      return captain;
    }
   // console.log('check 4');
    return captain;
  }

  async reorderElements(captain: Captain) {
    this.newPosition = this.newPosition  > this.captains.length ? this.captains.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === captain.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const captainToMove = this.captains[startIndex];
   // console.log('Item to move: ', this.captains[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.captains);
        console.log('Item to +1: ', this.captains[index+1]);

        this.captains[index] = this.captains[index+1];
        this.captains[index].position = index;
        // console.log('Move: ', this.captains[index+1]);
        // console.log('Move pos: ', this.captains[index].position);
        //await this.updateDB(this.captains[index]);
        this.captainService.update(this.captains[index]);
     //   console.log('Update DB: ', this.captains[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.captains[index] = this.captains[index-1];
        this.captains[index].position = index;
        this.captainService.update(this.captains[index]);
      }
    } 
    this.captains[endIndex] = captainToMove;
    this.captains[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.captainService.update(this.captains[endIndex]);
    
    // const myClonedArray = [];
    // this.captains.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.captains = myClonedArray;
   // this.getAllRecords();
  }
}
